export default __webpack_public_path__ + "static/media/beach.22402ac5.jpg";